import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { InstituteApi, WaitingPatientsResponse } from "@/apiGenerate/medserver";
import { useAppUserStore } from "@/stores/appUser";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { useRouter } from "vue-router";

export const useWaitingRoomsStore = defineStore('waitingRooms', () => {
    const instituteApi = new InstituteApi(medServerApiConfig);
    const router = useRouter();

    const waitingRooms = ref<WaitingPatientsResponse[]>([]);
    const currentInstitute = computed(() => useAppUserStore().currentHealthGroupMembership?.instituteWithRole?.instituteWithRoleId);

    async function updateWaitingRoomsInternal(instituteId: string) {
        if (instituteId && router.currentRoute.value.name === 'calendar') {
            await instituteApi.listWaitingPatientsByInstitute({instituteId: instituteId})
                .then(response => waitingRooms.value = response);
        }
    }

    async function updateWaitingRooms() {
        await updateWaitingRoomsInternal(currentInstitute.value);   
    }

    const updateWaitingRoomsFrequency = typeof process.env.VUE_APP_UPDATE_WAITING_ROOMS_SECONDS === 'undefined' ?
        60 :
        Number(process.env.VUE_APP_UPDATE_WAITING_ROOMS_SECONDS);

    watch(() => currentInstitute.value, updateWaitingRoomsInternal);

    return {
        updateWaitingRoomsFrequency,
        waitingRooms,
        currentInstitute,
        updateWaitingRooms,
    };
});
